export const calculateNextValidTime = (
  hours: number,
  minutes: number,
  stepMinute: number,
): { hours: number; minutes: number } => {
  const nextStep = Math.ceil(minutes / stepMinute) * stepMinute;
  const newMinutes = nextStep % 60;
  const hoursToAdd = Math.floor(nextStep / 60);
  const newHours = (hours + hoursToAdd) % 24;
  return { hours: newHours, minutes: newMinutes };
};
